import React from 'react';
import { Typography, Box } from '@mui/material';

function QuestHeader({ quest }) {
  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', mb: 2 }}>
      {quest.picture && (
        <img
          src={quest.picture}
          alt={quest.name}
          style={{
            height: 100,
            width: 'auto',
            borderRadius: '8px'
          }}
        />
      )}
      <Box>
        <Typography variant="h5" sx={{ mb: 2 }}>
          {quest.name}
        </Typography>
        {quest.description && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" color="text.secondary">
              {quest.description}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default QuestHeader;
